import { createBrowserRouter, redirect } from "react-router-dom";
import { AuthLayout, MainLayout } from "../Layout";
import { store } from "../Store/store";
import {
  AboutUs,
  Home,
  NotFound,
  Cooperation,
  Projects,
  ProjectDetails,
  Services,
  Brief,
  ProjectsList,
  EmploymentForm,
  Blogs,
  BlogDetails,
} from "../Pages/Main";

export const tokenProtector = () => {
  const token = store?.getState()?.userSlice?.token;

  if (!token) {
    return redirect("/auth");
  }

  return null;
};

const router = createBrowserRouter([
  {
    path: "",
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      // about
      {
        path: "about",
        children: [
          { index: true, element: <AboutUs /> },
          { path: ":seoSlug", element: <AboutUs /> },
        ],
      },
      // cooperation
      {
        path: "cooperation",
        children: [
          { index: true, element: <Cooperation /> },
          { path: ":seoSlug", element: <Cooperation /> },
        ],
      },
      // services
      {
        path: "services",
        children: [
          { index: true, element: <Services /> },
          { path: ":seoSlug", element: <Services /> },
        ],
      },
      // blogs
      {
        path: "blogs",
        children: [
          { index: true, element: <Blogs /> },
          { path: ":seoSlug", element: <Blogs /> },
        ],
      },
      // blog details
      {
        path: "blog-details",
        children: [
          { path: ":code", element: <BlogDetails /> },
          { path: ":code/:seoSlug", element: <BlogDetails /> },
        ],
      },
      // projects list
      {
        path: "projects-list",
        children: [
          { index: true, element: <ProjectsList /> },
          { path: ":seoSlug", element: <ProjectsList /> },
        ],
      },
      // projects
      {
        path: "projects",
        children: [
          { index: true, element: <Projects /> },
          { path: ":seoSlug", element: <Projects /> },
        ],
      },
      // project details
      {
        path: "project-details",
        children: [
          { path: ":code", element: <ProjectDetails /> },
          { path: ":code/:seoSlug", element: <ProjectDetails /> },
        ],
      },
      // employment form
      {
        path: "employment-form",
        children: [
          { index: true, element: <EmploymentForm /> },
          { path: ":seoSlug", element: <EmploymentForm /> },
        ],
      },
      // brief form
      {
        path: "brief-form",
        children: [
          { path: ":code", element: <Brief /> },
          { path: ":code/:seoSlug", element: <Brief /> },
        ],
      },
      // 404
      {
        path: "404",
        element: <NotFound />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
